import styled from 'styled-components';

export const CHART_WIDTH = 900;

export const Wrapper = styled.div`
	max-height: 400px;
	max-width: ${CHART_WIDTH}px;
`;
